import React, {useEffect, useState} from 'react';
import {Button, Col, DatePicker, Table, Row, Icon, Tooltip, notification} from "antd";
import {reportService} from "../../../../services/report.services";
import SelectField from "../../../select-field";
import {distributionCenterService} from "@services";
import ModalDeliveryInfo from "../../../modals/delivery-info";
import {httpRequest} from "../../../../services/http-request";
import ModalListOrdersDelivery from "../../../modals/list-orders-delivery";
import moment from "moment";
import i18n from "../../../../i18n";
import {Trans} from "react-i18next";
import { useConsignorFilter } from '../../../../hooks/use-consignor-filter';
import ConsignorFilterSelect from '../../../consignor-filter-select';

export default function StatsCargoTimes() {
  const consignorFilter = useConsignorFilter();
  const { isOwnerUser, consignors, selectedConsignor, setSelectedConsignor, getCompaniesWithConsignor } = consignorFilter;

  const [loading, setLoading] = useState(false);
  const [companiesLoaded, setCompaniesLoaded] = useState(false);
  const [isNeedUpdateReport, setIsNeedUpdateReport] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(true);
  const [errorMsg, setErrorMsg] = useState(null);

  const [dateStart, setDateStart] = useState(moment().startOf("month"));
  const [dateEnd, setDateEnd] = useState(moment().endOf("month"));

  const [distCenters, setDistCenters] = useState([]);
  const [selectedDistCenters, setSelectedDistCenters] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [response, getResponse] = useState(0);
  const [deliveryInfo, setDeliveryInfo] = useState(undefined);

  const [showModalOrdersDelivery, setShowModalOrdersDelivery] = useState(false);
  const [responseOrder, getResponseOrder] = useState(0);

  // полученные данные отчета
  const [reportData, setReportData] = useState([]);
  const [reportTotal, setReportTotal] = useState([]);

  const colW = (isOwnerUser ? 4 : 5);

  // перезагружаем компании при смене consignor
  useEffect(() => {
    if (!companiesLoaded) return;
    setCompaniesLoaded(false);
  }, [selectedConsignor])

  // при первом открытии автоматически запрашиваем данные
  useEffect(() => {
    if (loading === false) {
      setLoading(true);
      setIsNeedUpdateReport(true);

      if (!companiesLoaded) {
        getCompaniesWithConsignor()
          .then((response) => {
            setDistCenters(response);
            setCompaniesLoaded(true);
          }).catch((errorMsg) => {
          setErrorMsg(errorMsg);
          setCompaniesLoaded(true);
        });
      }
    }
  }, [companiesLoaded]);

  useEffect(() => {
    if (isNeedUpdateReport) {
      // запрос на получение данных отчета
      reportService
        .getStatsCargoTimes(
          selectedDistCenters,
          dateStart.format("YYYY-MM-D"),
          dateEnd.format("YYYY-MM-D"),
          isOwnerUser ? selectedConsignor : null
        )
        .then((reportData) => {
          let i = 0;
          let reportFullDataParsed = reportData.List
            .filter((item) => item.child === false)
            .map((item) => {
              i++;
              return {
                key: `center` + i,
                distributionCenter: item.distributionCenter,
                data: []
              }
            });
          reportFullDataParsed.forEach((distCenter) => {
            const filteredData = reportData.List.filter((item) => item.child === true && item.distributionCenter === distCenter.distributionCenter)
            distCenter.data = filteredData;
          })

          setIsNeedUpdateReport(false);
          setLoading(false);
          setReportData(reportFullDataParsed);
          setReportTotal(reportData.TotalInfo);

        }).catch((errorMsg) => {
        setIsNeedUpdateReport(false);
        setLoading(false);
        setErrorMsg(errorMsg);
      });
    }
  }, [isNeedUpdateReport, companiesLoaded])

  const closeModalHandler = () => {
    setShowModal(false);
    getResponse(0);
    setDeliveryInfo(undefined);
  }

  // получаем данные для модалки "История рейса"
  useEffect(() => {
    if (response !== 0) {
      let url = "delivery/get-delivery-history?deliveryId=" + response;
      httpRequest.get(url).then(function (res) {
        setDeliveryInfo(res.data);
        getResponse(0);
      }).catch((e) => {
        notification.error({
          message: i18n.t('components.notification.titles.historyError'),
          description: e,
        });
        return false;
      })
    }

  }, [response]);

  // отображение фатальной ошибки
  if (errorMsg) {
    return (<div className="content-error-block">{errorMsg}</div>);
  }

  // список столбцов таблиц
  const columns = [
    {
      title: '',
      width: 45
    },
    {
      title: <span dangerouslySetInnerHTML={{__html:i18n.t('reportsPage.statsCargoTimes.table.distributionCenter.title')}}/>,
      key: 'distributionCenter',
      dataIndex: 'distributionCenter',
      render: (text) => {
        return {
          children: <>{text}</>,
          props: {
            colSpan: 7,
          },
        }
      },
      width: 120
    },
    {
      title: <span dangerouslySetInnerHTML={{__html:i18n.t('reportsPage.statsCargoTimes.table.date.title')}}/>,
      render: (text) => {
        return {
          children: <></>,
          props: {
            colSpan: 0,
          },
        }
      },
      width: 120
    },
    {
      title: <span dangerouslySetInnerHTML={{__html:i18n.t('reportsPage.statsCargoTimes.table.carrier.title')}}/>,
      render: () => {
        return {
          children: <></>,
          props: {
            colSpan: 0,
          },
        }
      },
      width: 300
    },
    {
      title: <span dangerouslySetInnerHTML={{__html:i18n.t('reportsPage.statsCargoTimes.table.dateAppoint.title')}}/>,
      render: () => {
        return {
          children: <></>,
          props: {
            colSpan: 0,
          },
        }
      },
      width: 120
    },
    {
      title: <span dangerouslySetInnerHTML={{__html:i18n.t('reportsPage.statsCargoTimes.table.dateArrival.title')}}/>,
      render: () => {
        return {
          children: <></>,
          props: {
            colSpan: 0,
          },
        }
      },
      width: 120
    },
    {
      title: <span dangerouslySetInnerHTML={{__html:i18n.t('reportsPage.statsCargoTimes.table.dateStartLoad.title')}}/>,
      render: () => {
        return {
          children: <></>,
          props: {
            colSpan: 0,
          },
        }
      },
      width: 120
    },
    {
      title: <span dangerouslySetInnerHTML={{__html:i18n.t('reportsPage.statsCargoTimes.table.dateDeparture.title')}}/>,
      render: () => {
        return {
          children: <></>,
          props: {
            colSpan: 0,
          },
        }
      },
      width: 120
    },

  ];
  const nestedColumns = [
    {
      title: '',
      width: 45
    },
    {
      title: <></>,
      key: 'number',
      render: (record) => (
        <a className="link link--underline"
           href="#"
           onClick={(e) => {
             e.preventDefault();
             setShowModal(true);
             getResponse(record.deliveryId);
           }}
        >{record.number}</a>
      ),
      width: 120
    },
    {
      title: <></>,
      dataIndex: 'dateLoad',
      key: 'dateLoad',
      width: 120,
      render: (text) => {
        return <>{moment(text).format("D.MM.YYYY")}</>
      }
    },
    {
      title: <></>,
      dataIndex: 'partnerName',
      key: 'partnerName',
      width: 300
    },
    {
      title: <></>,
      dataIndex: 'dateAppoint',
      key: 'dateAppoint',
      className: "center",
      width: 120,
      render: (text) => {
        return <>{text? moment(text).format("D.MM.YYYY HH:mm") : ''}</>
      }
    },
    {
      title: <></>,
      dataIndex: 'dateArrival',
      key: 'dateArrival',
      className: "center",
      width: 120,
      render: (text) => {
        return <>{text? moment(text).format("D.MM.YYYY HH:mm") : ''}</>
      }
    },
    {
      title: <></>,
      dataIndex: 'dateStartLoad',
      key: 'dateStartLoad',
      className: "center",
      width: 120,
      render: (text) => {
        return <>{text? moment(text).format("D.MM.YYYY HH:mm") : ''}</>
      }
    },
    {
      title: <></>,
      dataIndex: 'dateDeparture',
      key: 'dateDeparture',
      className: "center",
      width: 120,
      render: (text) => {
        return <>{text? moment(text).format("D.MM.YYYY HH:mm") : ''}</>
      }
    },
  ]

  return (
    <>
      <div className="reports__header">
        <h1 className="content-header">{i18n.t('reportsPage.statsCargoTimes.title')}</h1>
        <Icon type='filter'
              theme={isFilterOpen ? '' : "filled"}
              onClick={() => {
                setIsFilterOpen(!isFilterOpen)
              }}
              className="reports__filter-toggle"/>
        {isFilterOpen && <div className={`reports__filter ${isFilterOpen ? 'is-open' : ""}`}>
          <Row gutter={12} style={{padding: "0", rowGap: "10px"}} type="flex" justify="start">
            {isOwnerUser &&
              <Col lg={colW} md={colW} sm={12} xs={24} style={{paddingRight: "10px"}}>
                <ConsignorFilterSelect
                  isOwnerUser={isOwnerUser}
                  consignors={consignors}
                  selectedConsignor={selectedConsignor}
                  onChange={(value) => {
                    setSelectedConsignor(value);
                    setDistCenters([]);
                    setSelectedDistCenters([]);
                  }}
                />
              </Col>
            }
            <Col lg={colW} md={colW} sm={12} xs={24} style={{paddingRight: "10px"}}>
              <SelectField
                name="distributionCenters"
                selectedValue={selectedDistCenters}
                values={distCenters}
                onChange={(value) => {
                  setSelectedDistCenters(value);
                }}
                notFoundText={i18n.t('reportsPage.statsCargoTimes.filter.distributionCenters.empty')}
                getErrors={() => {
                }}
                style={{width: "100%"}}
                mode={'multiple'}
              />
            </Col>
            <Col lg={colW} md={colW} sm={12} xs={24} style={{paddingRight: "10px"}}>
              <DatePicker
                style={{width: "100%"}}
                defaultValue={dateStart}
                format="DD.MM.YYYY"
                size="normal"
                name="dateStart"
                placeholder={i18n.t('reportsPage.statsCargoTimes.filter.dateStart.placeholder')}
                allowClear={false}
                onChange={(date) => {
                  setDateStart(date);
                }}
              />
            </Col>
            <Col lg={colW} md={colW} sm={12} xs={24} style={{paddingRight: "10px"}}>
              <DatePicker
                style={{width: "100%"}}
                defaultValue={dateEnd}
                format="DD.MM.YYYY"
                size="normal"
                name="dateEnd"
                placeholder={i18n.t('reportsPage.statsCargoTimes.filter.dateEnd.placeholder')}
                allowClear={false}
                onChange={(date) => {
                  setDateEnd(date);
                }}
              />
            </Col>
            <Col lg={colW} md={colW} sm={12} xs={24} style={{textAlign: 'right', height: '40px'}}>
              <Button type="primary"
                      htmlType="button"
                      onClick={() => {
                        setLoading(true);
                        setIsNeedUpdateReport(true);
                      }}
                      style={{backgroundColor: '#1CAA53', border: 'none', height: '100%', width: '100%'}}
              >
                {i18n.t('main.buttons.submit')}
              </Button>
            </Col>
          </Row>
        </div>}
        <Row gutter={12} style={{padding: "0", rowGap: "10px", marginTop: '10px'}} type="flex" justify="start">
          <Col lg={12} md={12} sm={24} xs={24} style={{textAlign: 'left', marginBottom: '5px'}}>{i18n.t('reportsPage.statsCargoTimes.reportTotal.total')}: {reportTotal.Total}</Col>
          <Col lg={12} md={12} sm={24} xs={24} style={{textAlign: 'left', marginBottom: '5px'}}>{i18n.t('reportsPage.statsCargoTimes.reportTotal.totalWithAppoint')}: {reportTotal.TotalWithAppoint}</Col>
          <Col lg={12} md={12} sm={24} xs={24} style={{textAlign: 'left', marginBottom: '5px'}}>{i18n.t('reportsPage.statsCargoTimes.reportTotal.TotalWithArrival')}: {reportTotal.TotalWithArrival}</Col>
          <Col lg={12} md={12} sm={24} xs={24} style={{textAlign: 'left', marginBottom: '5px'}}>{i18n.t('reportsPage.statsCargoTimes.reportTotal.TotalWithStartLoad')}: {reportTotal.TotalWithStartLoad}</Col>
          <Col lg={12} md={12} sm={24} xs={24} style={{textAlign: 'left', marginBottom: '5px'}}>{i18n.t('reportsPage.statsCargoTimes.reportTotal.TotalWithDeparture')}: {reportTotal.TotalWithDeparture}</Col>
        </Row>
      </div>
      <div className="reports__table">
        <div className="reports__table-wrapper">
          <Col span={24}>
            <Table
              style={{width: 'max-content'}}
              columns={columns}
              dataSource={reportData}
              bordered={true}
              locale={{emptyText: i18n.t('main.empty')}}
              rowKey="key"
              size={"small"}
              loading={loading}
              pagination={false}
              expandedRowRender={record => {
                return <Table
                  columns={nestedColumns}
                  rowKey="number"
                  showHeader={false}
                  pagination={false}
                  size={"small"}
                  expandIconAsCell={false}
                  expandIconColumnIndex={1}
                  locale={{emptyText: i18n.t('main.empty')}}
                  bordered={true}
                  footer={() => ''}
                  dataSource={record.data}
                />
              }}
              expandRowByClick={true}
              defaultExpandAllRows={false}
              expandIconAsCell={false}
              expandIconColumnIndex={0}
              footer={() => ''}
            />
          </Col>
        </div>
      </div>
      {deliveryInfo && <ModalDeliveryInfo
        deliveryInfo={deliveryInfo}
        isShow={showModal}
        setIsShow={closeModalHandler}
      />}
      {<ModalListOrdersDelivery
        isShow={showModalOrdersDelivery}
        setIsShow={setShowModalOrdersDelivery}
        deliveryId={responseOrder}
      />}
    </>
  );
}
